import { CurrentApplicationVersionsWidget } from "./widgets/current-application-versions";
import {LastDeploymentsWidget} from "./widgets/last-deployments";

export const widgets = {
  "applications:current-application-versions": CurrentApplicationVersionsWidget,
  "applications:last-deployments": LastDeploymentsWidget,
};
